import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ReduxFormInput extends Component {
  static propTypes = {
    // From Redux Form:
    // { input, label, type, meta: { touched, error } }

    // Required
    input: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,

    //Optional
    label: PropTypes.string,
    placeholder: PropTypes.string,
    error: PropTypes.string,
    meta: PropTypes.object,
    handleInputRemoval: PropTypes.func,
    optionalClasses: PropTypes.string,
    disabled: PropTypes.bool,
  }

  renderLabel(label) {
    const { disabled } = this.props;

    return label
    ? (
        <label className={disabled ? 'disabled' : null}>
          {label}
        </label>
      )
    : ''
  }

  handleRemoveButtonClick = (event) => {
    event.preventDefault();
    this.props.handleInputRemoval();
  }

  renderRemoveButton() {
    const { handleInputRemoval } = this.props;
    return handleInputRemoval
    ? (
      <a className="input-delete-button" onClick={(event)=> this.handleRemoveButtonClick(event)}>
        <svg className="icon"><use xlinkHref="#trash-can" /></svg>
      </a>
    ) : null
  }

  render() {
    const {
      input,
      label,
      meta: {
        touched,
        error
      },
      placeholder,
      type,
    } = this.props

    const {
      handleInputRemoval,
      optionalClasses,
    } = this.props

    return (
      <div
        className={`input-container${optionalClasses ? ' ' + optionalClasses : ''}${touched && error ? ' error' : ''}`}
      >
        {this.renderLabel(label)}
        <div className={`input-container-inner${handleInputRemoval ? ' removable' : ''}`}>
          <input
            {...input}
            type={type}
            placeholder={placeholder || label}
          />
          {this.renderRemoveButton()}
        </div>
        {touched && error &&
          <div className="input-error-message">
            {error}
          </div>
        }
      </div>
    )
  }
}


export default ReduxFormInput;



// WEBPACK FOOTER //
// ./src/components/Global/ReduxForms/ReduxFormInput.js